import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { duration as getDuration } from '../../utils/utils';
import Percentage from './percentage';

const useStyles = makeStyles(theme => ({
    primary: {
        fontSize: 18,
        marginRight: theme.spacing(1.5),
        fontWeight: 700
    },
    primaryLight: {
        color: '#fff'
    },
    primaryDark: {
        color: '#112435',
    },
}));

const Duration = ({ atmosphere, duration, percentage, theme }) => {
    const classes = useStyles();

    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            <Typography className={clsx(theme ? classes.primaryLight: classes.primaryDark, classes.primary)}>
                {getDuration(duration)}
            </Typography>
            { percentage != null && <Percentage percentage={percentage} theme={theme} />}
        </Box>
    )
}

export default Duration;
